import {KinesisEvent} from "../kinesis.event";
import {KINESIS} from "../../kinesis.consts";

export class LandingPagePlayNowClickKinesisEvent extends KinesisEvent {
  constructor() {
    super(
      KINESIS.CATEGORY.bolao,
      KINESIS.ACTION.landingPage,
      KINESIS.LABEL.playNow,
      KINESIS.VALUE.click
    );
  }
}
